import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { Link, useLocation, useMatch } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import PeopleIcon from '@mui/icons-material/People';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import SettingsIcon from '@mui/icons-material/Settings';

/**
 * Navigation component for the marketing module
 * Automatically detects if it's under /admin/marketing or /admin/business/marketing
 */
const MarketingNav = () => {
  const location = useLocation();
  const { pathname } = location;
  
  // Determine which path prefix to use
  const isBusinessAdmin = useMatch('/admin/business/marketing/*');
  const baseUrl = isBusinessAdmin ? '/admin/business/marketing' : '/admin/marketing';
  
  // Determine which tab should be active based on the current URL
  const [value, setValue] = React.useState(0);
  
  React.useEffect(() => {
    if (pathname.includes(`${baseUrl}/campaigns`) || pathname === baseUrl) {
      setValue(0);
    } else if (pathname.includes(`${baseUrl}/contacts`)) {
      setValue(1);
    } else if (pathname.includes(`${baseUrl}/lists`)) {
      setValue(2);
    } else if (pathname.includes(`${baseUrl}/settings`)) {
      setValue(3);
    }
  }, [pathname, baseUrl]);
  
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs 
        value={value} 
        onChange={(e, newValue) => setValue(newValue)} 
        aria-label="Marketing Navigation"
        sx={{
          '& .MuiTab-root': {
            minWidth: 'auto',
            px: 3,
          }
        }}
      >
        <Tab 
          icon={<EmailIcon />} 
          iconPosition="start" 
          label="Campaigns" 
          component={Link} 
          to={`${baseUrl}/campaigns`} 
        />
        <Tab 
          icon={<PeopleIcon />} 
          iconPosition="start" 
          label="Contacts" 
          component={Link} 
          to={`${baseUrl}/contacts`} 
        />
        <Tab 
          icon={<FormatListBulletedIcon />} 
          iconPosition="start" 
          label="Lists" 
          component={Link} 
          to={`${baseUrl}/lists`} 
        />
        <Tab 
          icon={<SettingsIcon />} 
          iconPosition="start" 
          label="Settings" 
          component={Link} 
          to={`${baseUrl}/settings`} 
        />
      </Tabs>
    </Box>
  );
};

export default MarketingNav; 